import { createContext, useContext, useEffect, useState } from "react";

const ThemeCtx = createContext({ cc: false, toggleCc: () => {}, setCc: () => {} });
const KEY = "cc_theme";

const readInitial = () => {
  const v = localStorage.getItem(KEY);
  if (v === null) return localStorage.getItem("briefing_cc") === "1"; // migrate old per-page key
  return v === "1";
};

export function ThemeProvider({ children }) {
  const [cc, setCcState] = useState(readInitial);

  useEffect(() => {
    localStorage.setItem(KEY, cc ? "1" : "0");
    localStorage.setItem("briefing_cc", cc ? "1" : "0"); // keep legacy key in sync
    document.body.classList.toggle("cc-active", cc);
  }, [cc]);

  const setCc = (v) => setCcState(!!v);
  const toggleCc = () => setCcState((p) => !p);

  return <ThemeCtx.Provider value={{ cc, toggleCc, setCc }}>{children}</ThemeCtx.Provider>;
}

export const useTheme = () => useContext(ThemeCtx);
